export default "__VITE_ASSET__qNCjNImM__"